import { fetchApi } from "./api";

export type AiaMemberInput = {
  first_name: string;
  last_name: string;
  suffix?: string | null;
  title?: string | null;
  org?: string | null;
  bio?: string | null;
  photo_url?: string | null;
  linkedin_url?: string | null;
  is_active?: boolean;
};

// Public: list AIA advisory members.
export const listAiaMembers = () =>
  fetchApi<any[]>("people", "listAiaMembers", {}, { auth: false });

export const createAiaMember = (opts: { data: AiaMemberInput }) =>
  fetchApi<any>("people", "createAiaMember", opts.data);

export const updateAiaMember = (opts: { data: AiaMemberInput & { id: string } }) =>
  fetchApi<any>("people", "updateAiaMember", opts.data);

export const deleteAiaMember = (opts: { data: { id: string } }) =>
  fetchApi<{ ok: true }>("people", "deleteAiaMember", opts.data);

